import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import {
  FormModeEnum,
  TableActionParams,
  NotificationService,
  ModalService,
  BackendService,
} from 'beyond-util';
import { SifarnikBase } from '../sifarnik-base/sifarnik-base';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-brendovi',
  templateUrl: './brendovi.component.html',
})
export class BrendoviComponent extends SifarnikBase
  implements OnInit, OnDestroy {
  private _subscriptions: Array<Subscription> = [];
  private _data: Array<any>;

  constructor(
    protected _backendService: BackendService,
    protected _modalService: ModalService,
    protected _notificationService: NotificationService,
    private _rtsBackendService: RtsBackendService,
    private _spinner: NgxSpinnerService
  ) {
    super(_backendService, _modalService, _notificationService);
  }

  ngOnInit() {
    setTimeout(() => {
      this._spinner.show();
      super.ngOnInit();
    });
  }

  ngOnDestroy() {
    this._subscriptions.forEach((s: Subscription) => s.unsubscribe());
  }

  changeName() {
    if (typeof this.order === 'undefined') {
      return;
    }

    if (this.order.hasOwnProperty('naziv')) {
      this.name = this.order.naziv;
    } else if (this.mode === FormModeEnum.Add) {
      this.name = 'Novi brend';
    } else if (this.order.hasOwnProperty('id')) {
      this.name = 'Brend';
    }
  }

  loadSettings() {
    this._subscriptions.push(
      this._rtsBackendService
        .fetchSettings(
          FormCode.MSSPO_BRE,
          FormName.SifarnikBrendova,
          EndpointTypes.AllEntities,
          this.filterQuery
        )
        .subscribe(data => {
          this._spinner.hide();

          if (!this.settingsTable) {
            this.setSettings(data['Settings']);
          }
          this.orderListCount = data['ServiceData']['DataSumCount'];
          this.setRbr(data['ServiceData']);
          this.setId(data['ServiceData']);
          this._data = data['ServiceData'];
          this.setAllFields();
          this.refreshTable();
        })
    );
  }

  refreshTable() {
    const data = {
      documentId: 'PregledBrendova',
      result: this._data,
      pageSize: 10,
      pageNumber: 1,
      count: this._data.length,
      menuCalled: false,
      error: 0,
    };

    this.orderList = data.result;
  }

  onTableActionFilter(event: any) {
    this._spinner.show();
    super.onTableActionFilter(event);
  }

  addOrder() {
    this._spinner.show();
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .save(FormCode.MSSPO_BRE, FormName.SifarnikBrendova, payload)
        .subscribe(() => {
          this.loadSettings();
        })
    );
  }

  updateOrder() {
    this._spinner.show();
    const payload = { ...this.order };
    this._subscriptions.push(
      this._rtsBackendService
        .update(FormCode.MSSPO_BRE, FormName.SifarnikBrendova, payload)
        .subscribe(() => {
          this.loadSettings();
        })
    );
  }

  getConfirmMessage(): string | any {
    return <any>(
      'Da li ste sigurni da želite da obrišete brend? Ukoliko se obriše, obrisaće se i na svim spotovima.'
    );
  }

  onDeleteConfirm() {
    this._spinner.show();
    this._subscriptions.push(
      this._rtsBackendService
        .delete(FormCode.MSSPO_BRE, FormName.SifarnikBrendova, this.order.Id)
        .subscribe(() => {
          this._notificationService.openNoty('Uspešno brisanje');
          this.changeMode(FormModeEnum.Table);
          this.loadSettings();
        })
    );
  }

  onTableActionUpdate(event: TableActionParams) {
    super.onTableActionUpdate(event);
    this.updateOrder();
  }

  onTableInlineSave() {
    this.addOrder();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/brendovi/brendovi.component.ts